import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useGridApiRef } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Excel from "exceljs";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";
import { useNavigate, useParams } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { ProductSystemTableColumn } from "@/config/tableColumnConfig";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// Mui Icon
import CreateProductDiscountDialog from "@/components/Dialog/createProductDiscountDialog";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
// import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// Fetch
import {
  createProductMonthlyDiscount,
  createStockSheet,
  exportToCsvByDate,
  exportToXls,
  fetchStockSheetTemplate,
  updateRebate,
} from "@/fetch/fetchProduct";
import { getRegionOptions } from "@/fetch/fetchWork";
import extractStock from "@/lib/extractStock";

// Moment
import Moment from "moment";
import { extendMoment } from "moment-range";
import "moment/locale/zh-hk";

import { useCurrentAction } from "@/hooks/user";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import moment from "moment";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const SystemSettingProductPage = (props) => {
  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const apiRef = useGridApiRef();
  const moment = extendMoment(Moment);

  const { date } = useParams();
  const datetime = moment(`${date}-01`).format("YYYY-MM-DD");

  // Navigate
  const navigate = useNavigate();

  // States
  const [productData, setProductData] = React.useState([]);
  const [selectedDate, setSelectedDate] = React.useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
  });
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [regions, setRegions] = React.useState([]);
  const [selectedRegion, setSelectedRegion] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [selectedPromotion, setSelectedPromotion] = React.useState({});
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const handleDownloadCsv = async () => {
    if (!loading) {
      setLoading(true);
      await exportToXls(selectedDate.startDate, selectedRegion).then(
        (response) => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Promotion (${datetime}).xlsx`);
          document.body.appendChild(link);
          link.click();
        },
      );
      setLoading(false);
    }
  };
  const field = {
    product_master_id: "A",
    m18_product_code: "B",
    mannings_product_code: "C",
    brand_types_id: "D",
    brand_types_name: "E",
    product_name: "F",
    product_unit_price: "G",
    product_discount_price: "H",
    pos_price: "I",
    product_discount_startdate: "J",
    product_discount_enddate: "K",
    discount_name: "L",
    discount_off: "M",
    discount_id: "N",
    promotion_id: "O",
    rebate_percent: "P",
  };
  const handleRebateUpload = (e) => {
    setSnackSeverity("info");
    setSnackMessage("上載中.....");
    setSnackOpen(true);
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    e.preventDefault();
    let rebate_data = [];
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then(async (workbook) => {
        workbook.eachSheet((sheet) => {
          if (sheet.name.includes("promotion-")) {
            sheet.eachRow((row, rowIndex) => {
              if (rowIndex > 1) {
                rebate_data.push({
                  promotion_id: row.getCell(field["promotion_id"]).value,
                  rebate_percent: row.getCell(field["rebate_percent"]).value,
                });
              }
            });
          }
        });
        try {
          await updateRebate(rebate_data);
          setSnackSeverity("success");
          setSnackMessage(`上傳成功`);
        } catch (err) {
          setSnackSeverity("error");
          setSnackMessage(`上傳失敗`);
        } finally {
          fetchAll();
          setSnackOpen(true);
        }
      });
    };
  };
  const handleOnChangeUpload = (e) => {
    setSnackSeverity("info");
    setSnackMessage("上載中.....");
    setSnackOpen(true);
    const wb = new Excel.Workbook();
    const reader = new FileReader();

    e.preventDefault();

    let invaildDatas = [];

    const requiredfield = [
      "product_master_id",
      "product_discount_price",
      "product_discount_startdate",
      "product_discount_enddate",
      "discount_name",
      "discount_id",
    ];
    const headers = [];
    const file = e.target.files[0];
    let result = [];
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then(async (workbook) => {
        workbook.eachSheet((sheet) => {
          const sheetResult = [];
          let region = 1;
          if (sheet.name.includes("promotion-")) {
            if (sheet.name.includes("澳門")) {
              region = 2;
            }
            sheet.eachRow((row, rowIndex) => {
              _.forEach(sheet.columns, (column) => {
                headers.push(column.values[1]);
              });
              const headerViald = requiredfield.every((i) =>
                headers.includes(i),
              );
              if (!headerViald) {
                setSnackMessage("上傳失敗\n原因:EXCEL格式錯誤");
                setSnackSeverity("error");
                setSnackOpen(true);
                return false;
              }
              if (rowIndex > 1) {
                sheetResult.push({
                  row: rowIndex,
                  product_discount_datetime: datetime,
                  work_region_id: region,
                  product_discount_startdate: moment(
                    row.getCell(field["product_discount_startdate"]).value,
                  ).format("YYYY-MM-DD"),
                  product_discount_enddate: moment(
                    row.getCell(field["product_discount_enddate"]).value,
                  ).format("YYYY-MM-DD"),
                  product_master_id: row.getCell(field["product_master_id"])
                    .value,
                  product_discount_price: _.round(
                    row.getCell(field["product_discount_price"]).result ??
                      row.getCell(field["product_discount_price"]).value,
                    2,
                  ),
                  pos_price: _.round(
                    row.getCell(field["pos_price"]).result ??
                      row.getCell(field["pos_price"]).value,
                    2,
                  ),
                  discount_id: row.getCell(field["discount_id"]).result?.error
                    ? null
                    : row.getCell(field["discount_id"]).result,
                });
              }
            });
            const groupCSVDataByMasterId = _.groupBy(
              sheetResult,
              "product_master_id",
            );
            _.forEach(groupCSVDataByMasterId, (csvDataByMasterId, key) => {
              csvDataByMasterId.flatMap((v, i) =>
                csvDataByMasterId.slice(i + 1).map((w) => {
                  const range1 = moment.range(
                    v.product_discount_startdate,
                    v.product_discount_enddate,
                  );
                  const range2 = moment.range(
                    w.product_discount_startdate,
                    w.product_discount_enddate,
                  );

                  const isOverlaps = range1.overlaps(range2, {
                    adjacent: true,
                  });
                  if (isOverlaps) {
                    invaildDatas.push({
                      row: v.row,
                      sheet: sheet.name,
                      reason: `與行${w.row}日期重疊\n`,
                    });
                  }
                }),
              );
            });
            const groupProductDatasByMasterId = _.groupBy(
              productData,
              "product_master_id",
            );
            const notAvailableDate = {};
            _.forEach(
              groupProductDatasByMasterId,
              (groupProductDataByMasterId, key) => {
                let date = [];
                _.forEach(groupProductDataByMasterId, (data) => {
                  if (data.is_active) {
                    const dateArr = enumerateDaysBetweenDates(
                      data.product_discount_startdate,
                      data.product_discount_enddate,
                    );

                    date = _.concat(date, dateArr);
                  }
                });
                notAvailableDate[key] = date;
              },
            );
            // Output
            _.forEach(sheetResult, (r, index) => {
              const startDate = moment(r.product_discount_startdate);
              const endDate = moment(r.product_discount_enddate);

              const selectedDateRange = enumerateDaysBetweenDates(
                startDate,
                endDate,
                "D/M/YYYY",
              );
              const difference = _.difference(
                selectedDateRange,
                notAvailableDate[r.product_master_id],
              );
              r.product_discount_startdate = startDate.format("YYYY-MM-DD");
              r.product_discount_enddate = endDate.format("YYYY-MM-DD");

              if (difference.length !== selectedDateRange.length) {
                invaildDatas.push({
                  row: r.row,
                  sheet: sheet.name,
                  reason: `與現有折扣日期重疊\n`,
                });
              }
              if (!r.product_master_id) {
                invaildDatas.push({
                  row: r.row,
                  sheet: sheet.name,
                  reason: `"product_master_id"不能為空"\n`,
                });
              }
              if (endDate.isBefore(startDate)) {
                invaildDatas.push({
                  row: r.row,
                  sheet: sheet.name,
                  reason: `"product_discount_enddate"不能大於"product_discount_startdate"\n`,
                });
              }
            });
            invaildDatas = _.filter(
              invaildDatas,
              (invaildData) => invaildData !== undefined,
            );
            result = _.concat(result, sheetResult);
          }
        });
        if (invaildDatas.length > 0) {
          let message = `上傳失敗\n原因:\n`;
          _.forEach(invaildDatas, (invaildData) => {
            message += `${invaildData.sheet} 行${invaildData.row}: ${invaildData.reason}`;
          });
          setSnackMessage(message);
          setSnackSeverity("error");
        } else {
          try {
            await createProductMonthlyDiscount(result);
            setSnackSeverity("success");
            setSnackMessage(`上傳成功`);
          } catch (err) {
            setSnackSeverity("error");
            setSnackMessage(`上傳失敗`);
          } finally {
            setSnackOpen(true);
          }
        }

        fetchAll();
      });
    };
    e.target.value = null;
  };
  const getRowId = (row) => {
    return row.id;
  };
  const handleOnSuccess = async (rows) => {
    const _rows = [...rows];
    _.forEach(_rows, (_row, index) => {
      _row.option = {
        setSnackOpen,
        setSnackSeverity,
        setSnackMessage,
      };
    });
    apiRef.current.updateRows([..._rows]);
  };
  // Fetch
  const fetchOption = async () => {
    const { data: workOptions } = await getRegionOptions();
    const uniqRegions = _.map(_.uniqBy(workOptions, "region_id"), (option) => ({
      region_id: option.region_id,
      region_name: option.region_name,
    }));
    setRegions(uniqRegions);
    if (!selectedRegion) {
      setSelectedRegion(uniqRegions[0].region_id);
    }
  };
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);

      await exportToCsvByDate(selectedDate.startDate, selectedRegion).then(
        (data) => {
          if (data.results) {
            const tempArr = [...data.data];
            for (let i = 0; i < tempArr.length; i++) {
              tempArr[i].product_discount_startdate = moment(
                tempArr[i].product_discount_startdate,
              ).format("YYYY-MM-DD");
              tempArr[i].product_discount_enddate = moment(
                tempArr[i].product_discount_enddate,
              ).format("YYYY-MM-DD");
              tempArr[i].product_discount_datetime =
                moment(datetime).format("YYYY-MM-DD");
              tempArr[i].selectedRegion = selectedRegion;
              tempArr[i].option = {
                setSnackOpen,
                setSnackSeverity,
                setSnackMessage,
              };
            }
            setProductData(tempArr);
          } else {
            setProductData([]);
          }
        },
      );
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    fetchOption();
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegion, selectedDate]);

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={12}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="產品折扣設定"
        history={() => navigate(-1)}
        children={
          <div>
            <Select
              labelId="region-select-label"
              name="region"
              id="region"
              value={selectedRegion}
              label="Region"
              onChange={(e) => setSelectedRegion(e.target.value)}
            >
              {regions.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.region_id}>
                    {item.region_name}
                  </MenuItem>
                );
              })}
            </Select>
            {/* Insert Record */}
            {actions?.create && (
              <IconButton
                component="label"
                onClick={() => setIsDialogOpen(true)}
              >
                <AddBoxIcon />
              </IconButton>
            )}
            {/* insert Record */}
            {actions?.upload && (
              <IconButton component="label">
                <DriveFolderUploadIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".xlsx"}
                  onChange={(e) => handleOnChangeUpload(e)}
                />
              </IconButton>
            )}
            {actions?.rebateSetting && (
              <IconButton component="label">
                <AttachMoneyIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".xlsx"}
                  onChange={(e) => handleRebateUpload(e)}
                />
              </IconButton>
            )}

            {/* Download CSV */}
            {actions?.download && (
              <IconButton
                component="label"
                onClick={handleDownloadCsv}
                disabled={productData.length > 0 ? loading : true}
              >
                <DownloadIcon />
              </IconButton>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"} alignItems={"left"}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 12,
                lg: 12,
              }}
            >
              <DatePicker
                label="開始日期"
                value={selectedDate.startDate}
                onChange={(newValue) =>
                  setSelectedDate((prev) => ({
                    ...prev,
                    startDate: newValue,
                  }))
                }
                renderInput={(params) => (
                  <TextField {...params} sx={{ width: "100%" }} />
                )}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      {isDialogOpen && (
        <CreateProductDiscountDialog
          region={selectedRegion}
          regions={regions}
          actions={actions}
          open={isDialogOpen}
          onClose={() => {
            setSelectedPromotion({});
            setIsDialogOpen(false);
          }}
          datetime={datetime}
          setSnackSeverity={setSnackSeverity}
          setSnackOpen={setSnackOpen}
          setSnackMessage={setSnackMessage}
          onSuccess={handleOnSuccess}
          fetchAll={fetchAll}
          productData={productData}
          selectedPromotion={selectedPromotion}
        ></CreateProductDiscountDialog>
      )}
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            apiRef={apiRef}
            getRowId={getRowId}
            loading={dataTableLoading}
            rows={productData}
            columns={ProductSystemTableColumn}
            pageSize={100}
            newEditingApi={true}
            onCellClick={(params) => {
              if (!["upload", "template"].includes(params.field)) {
                if (actions?.update) {
                  setSelectedPromotion(params.row);
                  setIsDialogOpen(true);
                }
              }
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default SystemSettingProductPage;

export const UploadExcel = (props) => {
  const { setSnackOpen, setSnackMessage, setSnackSeverity } = props.row.option;
  const handleImport = async (e) => {
    try {
      const extractData = await extractStock(e, props.row.id);
      await createStockSheet(extractData);
      setSnackSeverity("success");
      setSnackMessage("上載成功");
    } catch (error) {
      setSnackSeverity("error");
      if (error === "discount_not_match") {
        setSnackMessage(`上載失敗\n請上載正確檔案`);
      } else {
        setSnackMessage(`上載失敗 \n ${error}`);
      }
    } finally {
      setSnackOpen(true);
    }

    e.target.value = null;
  };
  return (
    <Box component="label">
      <Button component="label" startIcon={<FileUploadIcon />}>
        <VisuallyHiddenInput
          type="file"
          onChange={async (e) => {
            await handleImport(e);
          }}
          accept={".xlsx"}
          multiple
        />
      </Button>
    </Box>
  );
};

export const DownLoadTemplate = (props) => {
  const downLoadTemplate = async (params) => {
    const {
      product_discount_startdate,
      region_id,
      id,
      product_discount_enddate,
      product_name,
      discount_name,
    } = params;
    try {
      await fetchStockSheetTemplate(
        product_discount_startdate,
        region_id,
        id,
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${product_name} - ${discount_name}(${moment(
            product_discount_startdate,
          ).format("YYYY-MM-DD")} - ${moment(product_discount_enddate).format(
            "YYYY-MM-DD",
          )}).xlsx`,
        );
        document.body.appendChild(link);
        link.click();
      });
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <Box component="label">
      <Button
        startIcon={<DownloadIcon />}
        onClick={() => downLoadTemplate(props.row)}
      >
        {props.row.stock_sheet_record_count}
      </Button>
    </Box>
  );
};
